import React from 'react';
import { useSEO } from '../contexts/SEOContext';
import VariantSolutions from './variants/VariantSolutions';

const Solutions = () => {
  const { currentSEO } = useSEO();
  
  return (
    <div>
      <VariantSolutions />
    </div>
  );
};

export default Solutions; 